import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import useTranslations from "../Translations/useTranslations";
import AnimationSlideRight from "../../Animation/AnimationSlideRight";
import AnimationSlideLeft from "../../Animation/AnimationSlideLeft";
import { fetchData } from "../../BaseUrl";

function Accredited() {
  const isMobile = useMediaQuery("(max-width:600px)");
  useTranslations();
  const [accredited, setAccredited] = useState([]); // ✅ Store multiple items

  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f9f5ff",
      padding: isMobile ? "1rem" : "2rem 4rem",
    },
    heading: {
      fontSize: isMobile ? "22px" : "30px",
      fontWeight: "bold",
      color: "#000",
      marginBottom: "10px",
      textAlign: "left",
    },
    subheading: {
      fontSize: isMobile ? "14px" : "16px",
      color: "#333",
      marginBottom: "20px",
      textAlign: "left",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      paddingRight: isMobile ? "10px" : "30px",
    },
    image: {
      width: isMobile ? "80%" : "60%",
      height: "auto",
      maxWidth: "250px",
      maxHeight: "250px",
      borderRadius: "8px",
    },
  };

  useEffect(() => {
    getAccredited();
  }, []);

  const getAccredited = async () => {
    try {
      const response = await fetchData("/admin/accreditation/list");
      if (response?.data?.length) {
        setAccredited(response.data); // ✅ Store all accreditation data
      } else {
        setAccredited([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setAccredited([]);
    }
  };

  return (
    <div style={{ paddingTop: "6rem", minHeight: "60vh" }}>
      <Box sx={styles.container}>
        <Grid container spacing={4}>
          {accredited.length > 0 ? (
            accredited.map((item, index) => (
              <React.Fragment key={item.id}>
                {/* Left Side: Text Content */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <AnimationSlideLeft duration={1.4} rootMargin={"-10px"}>
                    <Box sx={{ p: 4 }}>
                      <Typography sx={styles.heading}>{item.name}</Typography>
                      <Typography sx={styles.subheading}>{item.description}</Typography>
                    </Box>
                  </AnimationSlideLeft>
                </Grid>

                {/* Right Side: Image */}
                <Grid item xs={12} md={6} p={2}>
                  <AnimationSlideRight duration={1.4} rootMargin={"-10px"}>
                    <Box sx={styles.imageContainer}>
                      {item.certificateUrl ? (
                        <img
                          src={item.certificateUrl}
                          style={styles.image}
                          alt="Accreditation Certificate"
                        />
                      ) : (
                        <Typography>No Image Available</Typography>
                      )}
                    </Box>
                  </AnimationSlideRight>
                </Grid>
              </React.Fragment>
            ))
          ) : (
            <Typography>No Accreditation Data Available</Typography>
          )}
        </Grid>
      </Box>
    </div>
  );
}

export default Accredited;
